export default {"src":"/_next/static/image/src/assets/footer/instagram.abad97d7ae4449c7df6194c934095e4a.svg","height":24,"width":24};